<template lang="pug">
.cp-banner-btn(@click="showModal")
  span 免费体验
  icon.icon(iconClass="icongengduo-white")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus">
.cp-banner-btn
  width 200px
  height 50px
  line-height 48px
  text-align center
  background #16AABA
  color #FFFFFF
  border-radius 5px
  border 1px solid rgba(98,242,255,1)
  font-weight 600
  transition all .5s
  font-size 18px
  cursor pointer
  &:hover
    background #1ad1e4
  span
    font-size 18px
  .icon
    margin-left 10px
</style>
